.card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
}

.iconBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent-soft);
}

.icon {
  width: 22px;
  height: 22px;
  background-color: currentColor;
}

.title {
  font-size: 18px;
}

.text {
  font-size: 15px;
  line-height: 1.55;
  color: var(--ink-2);
}

.record {
  -webkit-mask: url('./record.svg') no-repeat center / contain;
  mask: url('./record.svg') no-repeat center / contain;
}

.check {
  -webkit-mask: url('./check.svg') no-repeat center / contain;
  mask: url('./check.svg') no-repeat center / contain;
}

.calendar {
  -webkit-mask: url('./calendar.svg') no-repeat center / contain;
  mask: url('./calendar.svg') no-repeat center / contain;
}

.pen {
  -webkit-mask: url('./pen.svg') no-repeat center / contain;
  mask: url('./pen.svg') no-repeat center / contain;
}

.patients {
  -webkit-mask: url('./patients.svg') no-repeat center / contain;
  mask: url('./patients.svg') no-repeat center / contain;
}

.chart {
  -webkit-mask: url('./chart.svg') no-repeat center / contain;
  mask: url('./chart.svg') no-repeat center / contain;
}

.download {
  -webkit-mask: url('./download.svg') no-repeat center / contain;
  mask: url('./download.svg') no-repeat center / contain;
}
